import React from 'react';
import Header from '../components/Frontend/Header';
import Footer from '../components/Frontend/Footer';
import FameWall from '../components/Frontend/FameWall';
import Testimonial from '../components/Frontend/Testimonial';
import VideoTuts from '../components/Frontend/VideoTuts';
import WhyLove from '../components/Frontend/WhyLove';
import { Link} from 'react-router-dom';
import { Helmet } from "react-helmet";
import ReactGA from 'react-ga';
import ReactPixel from 'react-facebook-pixel';
import Slider from "react-slick";


class Home extends React.Component {

  constructor(props) {
    super(props);
    this.state = {
      isActive: false,
    };
  }
  handleClick = () => {
    this.setState((prevState) => ({
      isActive: !prevState.isActive,
    }));
  };


    componentDidMount() {
        ReactGA.initialize('UA-157984080-1');
        ReactGA.pageview(window.location.pathname + window.location.search);
        
        ReactPixel.init('197333187452630');
        // ReactPixel.pageView();
    }
 render(){
  const customslider = {
    dots: false,
    arrows: false,
    infinite: true,
    slidesToShow: 1,
    slidesToScroll: 1,
    autoplay: true,
    autoplaySpeed: 4000,
};
    return (
    <React.Fragment>
    <Helmet>
        <title>PTE Reading Test Practice Material | LA Language Academy</title>
        <meta name="description" content="Refine your PTE reading skills with LA Language Academy's online practice tests. Practice authentic mock questions, track progress & boost your exam score." />
        <meta name="robots" content="index, follow" />
        <link rel="canonical" href={`https://www.languageacademy.com.au/pte-reading-test-practice-material`} />
        <meta name="twitter:card" content="summary_large_image" />
        <meta name="twitter:site" content="@languageacademy" />
        <meta name="twitter:title" content="PTE Reading Test Practice Material | LA Language Academy" />
        <meta name="twitter:description" content="Refine your PTE reading skills with LA Language Academy's online practice tests. Practice authentic mock questions, track progress & boost your exam score." />
        <meta name="twitter:image" content={`https://www.languageacademy.com.au/images/logol.png`} />
        <meta name="twitter:image:alt" content="LA Language Academy Logo" />
        <meta property="og:url" content={`https://www.languageacademy.com.au/pte-reading-test-practice-material`} />
        <meta property="og:type" content="website" />
        <meta property="og:title" content="PTE Reading Test Practice Material | LA Language Academy" />
        <meta property="og:description" content="Refine your PTE reading skills with LA Language Academy's online practice tests. Practice authentic mock questions, track progress & boost your exam score." />
        <meta property="og:image" content={`https://www.languageacademy.com.au/images/logol.png`} />
        <meta property="og:image:alt" content="LA Language Academy Logo" />
        <meta property="og:image:width" content="1200" />
        <meta property="og:image:height" content="630" />
      </Helmet>
    <Header />
    <div className="hero-section mt-80">
            <div className="container">
               <div className="row">
               <div className="col-lg-8 col-md-8">
                  <div className="hero-content">
                     <h1 className="primary-heading mfw-600">
                     Refine your reading
                        <br className='d-none d-lg-block' /> skills using
                        the Best <br className='d-none d-lg-block' />
                        PTE Reading Practice <br className='d-none d-lg-block' />
                        Test Material
                     </h1>
                     <p className="sub-heading bold-sub-heading">
                        Practice the latest PTE Reading Mock Test questions
                        <br className='d-none d-md-block' />
                        regularly and attain your target score
                     </p>
                     <div className="text-center text-md-start">
                     <Link to="/auth/register" className="primary-btn">REGISTER NOW <img src="/images/web-new-images/right-arrow.svg" alt="LA" /></Link>
                     </div>
                  </div>
               </div>
               <div className="col-lg-4 col-md-4">
                  <div className="hero-img-wrapper">
                     <img
                     className="img-fluid"
                     src="/images/web-new-images/bannerImg.png"
                     alt="LA"
                     />
                  </div>
               </div>
               </div>
            </div>
         </div>
         <div className="pte-content-section wrsl-content-section">
				<div className="circle-section">
					<div className="container pte-container">
						<div className="row">
							<div className="col-md-12">                  
								<div className="position-relative">
									<ul className="m-0">
                    <li>
                    Are you searching for the best PTE reading practice material? If yes, you can nimbly make a buying decision with us because we know the winning strategy for PTE online reading test that not only focuses on the reading part but can also give you an idea about the best writing techniques. Today, a few aspirants don't take the PTE academic reading practice test seriously due to overconfidence and low priority level, but this is also crucial like other tests.
                    </li>
									</ul>
								</div>
								<div className="pte-bottom-content">
                  <div>
                    <div onClick={this.handleClick} className="pte-bottom-header d-flex justify-content-center align-items-center">
                    <h3 className="m-0">
                      <a href="javascript:void(0)" className='text-decoration-none'>Read More</a>
                    </h3>
                    <img
                      src="/images/web-new-images/icons/bottom-arrow-01.png"
                      alt="LA"
                    />
                    </div>
                    <ul className={`hide-content ${this.state.isActive ? "active" : ""}`}> 
                      <li className='no-dot'> <h4 className='pte-bottom-heading'>Before moving on to the next step, we should know about the importance of PTE reading practice test.</h4></li>
                      <li>
                      By using the PTE reading mock test, we can easily enhance our vocabulary and make ourselves aware of the words with which we were not familiar earlier.
                      </li>
                      <li>
                      An aspirant can get an idea about the content structure from the paragraph mentioned in the PTE reading material.
                      </li>
                      <li>
                      Apart from these two benefits, the aspirant can also learn the content writing techniques by reviewing the PTE exam reading practice test.
                      </li>
                      <li>
                      One can also learn the usage of different words from PTE academic reading material.
                      </li>
                      <li className='no-dot'>
                      After knowing these immense benefits, do you want to avail the best PTE reading material? You can contact us over a call on <a href="tel:+61426230061" target="blank">+61 426230061</a> and start your PTE reading practice online with us now!
                      </li>
                    </ul>
                  </div>
								</div>								
							</div>
              <div className="text-center">
              <Link to="/auth/register" className="primary-btn">REGISTER NOW <img src="/images/web-new-images/right-arrow.svg" alt="LA" /></Link>
              </div>
						</div>
					</div>				
				</div>
			</div> 
        <div className="prepare-section wrsl-card-section">
          <div className="container">
              <div className="row">
              <div className="col-md-12">                
                <div className="prepare-cards">
                    <div className="position-relative">
                      <Link to="/pte-listening-test-practice-material"></Link>
                      <div className='prepare-card listening-card'>
                        <div className="img-wrapper">
                            <img
                            src="/images/web-new-images/icons/language-01.png"
                            alt="LA"
                            />
                        </div>
                        <h2 className="card-title">Listening</h2>
                        <p className="card-description">
                        Start preparing for the listening section using the latest practice material.
                        </p>                      
                      </div>
                    </div>
                    <div className="position-relative">
                      <Link to="/pte-writing-test-practice-material"></Link>
                      <div className='prepare-card writing-card'>
                          <div className="img-wrapper">
                            <img
                            src="/images/web-new-images//icons/language-02.png"
                            alt="LA"
                            />
                          </div>
                          <h2 className="card-title">Writing</h2>
                          <p className="card-description">
                          Sharpen your writing skills with the best PTE writing practice material.
                          </p>                      
                      </div>
                    </div>
                    <div className="position-relative">
                      <Link to="/pte-speaking-test-practice-material"></Link>
                      <div className='prepare-card speaking-card'>
                          <div className="img-wrapper">
                            <img
                            src="/images/web-new-images//icons/language-03.png"
                            alt="LA"
                            />
                          </div>
                          <h2 className="card-title">Speaking</h2>
                          <p className="card-description">
                          Get the guidance from our experts and remove all the hurdles that you face in PTE speaking test module.
                          </p>                      
                      </div>
                    </div>
              </div>
              <div className="text-start text-md-center bottom-btn-wrapper">
                    <p className="sub-heading ">
                    Let’s make your learning meaningful and successful!
                    </p>
                    <Link to="/auth/register" className="primary-btn">REGISTER NOW <img src="/images/web-new-images/right-arrow.svg" alt="LA" /></Link>
                </div>
              </div>
          </div>
          </div>
        </div>       
        <div className="exam-pattern-section pte-exam-pattern pcs-exam-pattern py-0">
          <div className="container">
            <div className="row">
            <h2 className="primary-heading text-center">
            Why People Love <br className='d-block' /><span className="wpl-badge pte-naati-badge text-white">Language Academy</span></h2> 
            <p className="sub-heading text-center">
            We provide the top-rated PTE training to the candidates <br className='d-none d-md-block' /> to make their career journey smooth
            </p>
            <div className="pattern-cards-outer mb-0">  
              <div className="exam-pattern-cards position-relative">                
                <Slider {...customslider}>
                <div className="exam-pattern-card">
                      <div className="img-wrapper">
                        <img
                          src="/images/web-new-images/icons/speaking-icon.svg"
                          alt="LA"
                        />
                      </div>
                      <h3 className="card-title">Experienced Trainer
                      </h3>
                      <p>We have Pearson certified faculty members...
                      </p>                      
                    </div>               
                    <div className="exam-pattern-card">
                      <div className="img-wrapper">
                        <img
                          src="/images/web-new-images/icons/speaking-icon.svg"
                          alt="LA"
                        />
                      </div>
                      <h3 className="card-title">Highest Success Rate</h3>
                      <p>Students will get a sure-shot success with the high...
                      </p>                      
                    </div>             
                    <div className="exam-pattern-card">
                      <div className="img-wrapper">
                        <img
                          src="/images/web-new-images/icons/speaking-icon.svg"
                          alt="LA"
                        />
                      </div>
                      <h3 className="card-title">Free Books</h3>
                      <p>Our PTE / NAATI training institute provides free books...
                      </p>                      
                    </div>              
                    <div className="exam-pattern-card">
                      <div className="img-wrapper">
                        <img
                          src="/images/web-new-images/icons/speaking-icon.svg"
                          alt="LA"
                        />
                      </div>
                      <h3 className="card-title">Latest Resources</h3>
                      <p>Making use of the latest technology, we provide...
                      </p>                      
                    </div>              
                    <div className="exam-pattern-card">
                      <div className="img-wrapper">
                        <img
                          src="/images/web-new-images/icons/speaking-icon.svg"
                          alt="LA"
                        />
                      </div>
                      <h3 className="card-title">Online Support</h3>
                      <p>Our experts are always there to help the students through...
                      </p>                      
                    </div>               
                    <div className="exam-pattern-card">
                      <div className="img-wrapper">
                        <img
                          src="/images/web-new-images/icons/speaking-icon.svg"
                          alt="LA"
                        />
                      </div>
                      <h3 className="card-title">3500 + Questions to Practice</h3>
                      <p>We give the students various exercises and practice
                      </p>                      
                    </div>               
                    <div className="exam-pattern-card">
                      <div className="img-wrapper">
                        <img
                          src="/images/web-new-images/icons/speaking-icon.svg"
                          alt="LA"
                        />
                      </div>
                      <h3 className="card-title">Discussion Sessions</h3>
                      <p>During the discussion sessions, Our experienced team...
                      </p>                      
                    </div>               
                    <div className="exam-pattern-card">
                      <div className="img-wrapper">
                        <img
                          src="/images/web-new-images/icons/speaking-icon.svg"
                          alt="LA"
                        />
                      </div>
                      <h3 className="card-title">Affordable Fees</h3>
                      <p>We offer the best PTE and NAATI coaching classNamees...
                      </p>                      
                    </div>               
                    <div className="exam-pattern-card">
                      <div className="img-wrapper">
                        <img
                          src="/images/web-new-images/icons/speaking-icon.svg"
                          alt="LA"
                        />
                      </div>
                      <h3 className="card-title">Real Time Test Environment</h3>
                      <p>We provide several mock tests for reading, listening...
                      </p>                      
                    </div>                                 
                </Slider>
              </div>
              <div className="text-center">
                <Link to="/auth/register" className="dark-border primary-btn">
                REGISTER NOW <img src="/images/web-new-images/right-arrow.svg" alt="Register Now" />
                </Link>
              </div>
            </div>
            </div>
          </div>
        </div> 
          <Testimonial />
          < VideoTuts />
          <div className="faq-section mt-faq">
            <div className="container">
              <div className="row">
                <h2 className="secondary-heading text-center">
                  Frequently Asked Questions
                </h2>

                <div className="accordion" id="accordionExample">
                  <div className="accordion-item">
                    <h2 className="accordion-header" id="headingOne">
                      <button
                        className="accordion-button"
                        type="button"
                        data-bs-toggle="collapse"
                        data-bs-target="#collapseOne"
                        aria-expanded="true"
                        aria-controls="collapseOne"
                      >
                        What is the recommended number of PTE mock tests that I should undertake?
                      </button>
                    </h2>
                    <div
                      id="collapseOne"
                      className="accordion-collapse collapse show"
                      aria-labelledby="headingOne"
                      data-bs-parent="#accordionExample"
                    >
                      <div className="accordion-body">
                      It is recommended to take three complete PTE mock tests.
                      </div>
                    </div>
                  </div>
                  <div className="accordion-item">
                    <h2 className="accordion-header" id="headingTwo">
                      <button
                        className="accordion-button collapsed"
                        type="button"
                        data-bs-toggle="collapse"
                        data-bs-target="#collapseTwo"
                        aria-expanded="false"
                        aria-controls="collapseTwo"
                      >
                        What is the PTE requirement for canada?
                      </button>
                    </h2>
                    <div
                      id="collapseTwo"
                      className="accordion-collapse collapse"
                      aria-labelledby="headingTwo"
                      data-bs-parent="#accordionExample"
                    >
                      <div className="accordion-body">
                      The minimum PTE score for Bachelor's programs, Advanced Diplomas, and Post Graduate Programs is 60, with a minimum band score of 53. Students with an overall score of 56 and each band score of at least 51 have also been granted study permits.
                      </div>
                    </div>
                  </div>
                  <div className="accordion-item">
                    <h2 className="accordion-header" id="headingThree">
                      <button
                        className="accordion-button collapsed"
                        type="button"
                        data-bs-toggle="collapse"
                        data-bs-target="#collapseThree"
                        aria-expanded="false"
                        aria-controls="collapseThree"
                      >
                        What is the duration of a full-length PTE mock test?
                      </button>
                    </h2>
                    <div
                      id="collapseThree"
                      className="accordion-collapse collapse"
                      aria-labelledby="headingThree"
                      data-bs-parent="#accordionExample"
                    >
                      <div className="accordion-body">
                      Around 2 hours. Students can attempt the test in one go or by taking short breaks.
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            </div>
        </div>
    <Footer />
    </React.Fragment>);
    }
}

export default Home;
